// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  battleId: __t.u64().primaryKey().name("battle_id"),
  warId: __t.u64().name("war_id"),
  worldId: __t.u64().name("world_id"),
  aggressorSid: __t.u64().name("aggressor_sid"),
  defenderSid: __t.u64().name("defender_sid"),
  phase: __t.string(),
  kind: __t.string(),
  targetX: __t.f32().name("target_x"),
  targetZ: __t.f32().name("target_z"),
  generalA: __t.u64().name("general_a"),
  generalB: __t.u64().name("general_b"),
  planA: __t.string().name("plan_a"),
  planB: __t.string().name("plan_b"),
  round: __t.u32(),
  strengthA: __t.u32().name("strength_a"),
  strengthB: __t.u32().name("strength_b"),
  winner: __t.string(),
  summary: __t.string(),
  startedAt: __t.timestamp().name("started_at"),
  engagedAt: __t.timestamp().name("engaged_at"),
  endsAt: __t.timestamp().name("ends_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
